module.exports = __webpack_public_path__ + "static/media/bio.74c8ec99.png";